import baguetteBox from 'baguettebox.js';

document.addEventListener("DOMContentLoaded", function (event) {
    baguetteBox.run('.js-property-detail-gallery');
});
